module.exports = __webpack_public_path__ + "img/health.svg";